<template>
  <div class="container page" style="background-color: #1f1c1f;">
    <van-nav-bar :title="$t('q32')" class="nav-bar">
      <template #left>
        <img src="/img/newLogin/download.png" @click="back()" style="width: 20px;height: 15px;"/>
      </template>
    </van-nav-bar>
    <div class="main-content">
      <div class="item" @click="toLink('/Infomation')">

        <div class="left">{{$t('q33')}}</div>
        <div class="right">
          
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="item-border"></div>
      <div class="item" @click="toLink('/SetLoginPassword')">
        <div class="left">{{$t('q34')}}</div>
        <div class="right">
          
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="item-border"></div>
      <div class="item" @click="toLink('/SetPayPassword')">
        <div class="left">{{$t('q35')}}</div>
        <div class="right">
          
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="item-border"></div>
      <div class="item" @click="toLanguage">
        <div class="left">{{$t('setting.language')}}</div>
        <div class="right">
          <span class="language-name">{{currentLanguage}}</span>
          <van-icon name="arrow" />
        </div>
      </div>
    </div>
    <div class="btn_out">
       <van-button  @click="loginout()" >
                {{$t("setting.logout")}}
        </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      show: false,
      isBank: false,
      userInfo: {}
    };
  },
  methods: {
    toLanguage() {
      this.$router.push({ name: 'Language', params: { type: 'setting' } });
    },
    loginout() {
      localStorage.clear()
      this.$router.push({ path: '/Login' });
    },
    toLink(path){
      this.$router.push({path:path});
    },
    back() {
      return window.history.back();
    },
    toSetName() {
      this.$router.push({ path: '/Setname' });
    },
    toSetBank() {
      this.$router.push({ path: '/Setbank' });
    },
    toSetSex() {
      this.$router.push({ path: '/Setsex' });
    },
    select_header_img(url) {
      this.isActive = url;
    },
    check() {
      this.$http({
        method: 'post',
        data: { header_img: this.isActive },
        url: 'user_header_img'
      }).then(res => {
        if (res.code === 200) {
          this.getUserInfo();
          this.$toast(res.msg);
          this.show = false;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res.code === 200) {
          this.userInfo = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo() {
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res => {
        if (res.code === 200) {
          if (res.data.is_bank) {
            this.isBank = true;
          } else {
            this.isBank = false;
          }
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  computed: {
    currentLanguage() {
      const labels = { ja: '日本語', en: 'English', es: 'Español' };
      return labels[this.$i18n.locale] || labels.ja;
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.item-border{
  height: 1px;
  width: 96%;
  background-color: #2c3038;
  margin-left: 4%;
}
.btn_out{
  ::v-deep .van-button{
    margin: 26px 0;
    background: linear-gradient(120deg,#212121,#313131)!important;
    color: #e6b98a;
     .van-button__text{
      color: #e6b98a;
      padding: 10px 0;
    }
    font-size: 30px;
    border: none;
    width: 100%;
    padding: 20px 0;
    height: initial;
    border-top: 1px solid #766350;
    border-bottom: 1px solid #766350;
  }
  
}

.container .main-content {
  padding: 0 20px;
  background:linear-gradient(120deg,#212121,#313131)!important;
  color: #eee;
  
}

.container .main-content .item {
  padding: 30px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 30px;
}

.container .main-content .item .right {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.language-name {
  margin-right: 15px;
  color: #e6b98a;
  font-size: 26px;
}

.container .main-content .item .right img {
  width: 90px;
}

.container .main-content .van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.container .main-content .item .right .desc-cell-number,
.container .main-content .item .right .desc {
  font-size: 30px;
  font-weight: 700;
  color: #979799;
}

.avatarbox {
  padding: 15px;
  color: #000;
  height: 81%;
  background-color: #fff;
}

.avatarbox .title {
  padding: 8px 10px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
}

.avatarbox .content .van-image {
  width: 105px;
  height: 105px;
  margin: 2.5%;
  border-radius: 50%;
}

.avatarbox .content {
  padding-bottom: 10px;
  height: 100%;
  overflow-y: auto;
  padding-top: 20px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.avatarbox .content .choose {
  width: 95px;
  height: 95px;
  border: 6px solid #e6c3a1;
}
</style>
